import { Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";

export const Gender = ({ gender, message }) => {
  return (
    <>
      <Row>
        <Col sm={12} className="col-12">
          <OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
            <Card>
              <Card.Header>
                <h3 className="card-title mb-0">Huespedes Por Genero</h3>
              </Card.Header>
              <Card.Body>
                <div className="table-responsive">
                  <Table className="table text-nowrap text-md-nowrap mg-b-0">
                    <tbody>                                            
                        <tr >
                          <td>Hombres</td>
                          <td>{gender.male || 0}</td>
                        </tr>
                        <tr >
                          <td>Mujeres</td>
                          <td>{gender.female || 0}</td>
                        </tr>
                        <tr >
                          <td>Sin Especificar</td>
                          <td>{(gender.total || 0) - ((gender.male || 0) + (gender.female || 0))}</td>
                        </tr>                      
                      <tr style={{ fontWeight: "bold" }}>
                        <td>Total</td>
                        <td>{gender.total || 0}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </OverlayTrigger>
        </Col>
      </Row>
    </>
  )
}
